"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _elements = require("../../styles/elements");

var attachment = function attachment(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.superLight, ";border:1px solid ", theme.color.monochrome.medium, ";border-radius:4px;color:", theme.color.monochrome.mediumDark, ";width:400px;display:flex;align-items:flex-start;justify-content:space-between;padding:5px 8px;line-height:", theme.lineHeight.leadingTight, ";overflow:hidden;h5{", _elements.heading.styles.preflight, ";font-size:inherit;color:", theme.color.monochrome.dark, ";font-weight:", theme.fontWeight.medium, ";&>span:not(:first-of-type){color:", theme.color.monochrome.mediumDark, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:attachment;"));
};

var controls = function controls(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;&>*{cursor:pointer;display:flex;align-items:center;color:inherit;margin-left:4px;&:hover{color:", theme.color.monochrome.dark, ";}svg{width:16px;height:16px;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
};

var attachments = function attachments(theme) {
  return /*#__PURE__*/(0, _react.css)("margin:-4px 0;&>*{margin:4px 0;}h4{", _elements.heading.styles.preflight, ";font-size:inherit;font-weight:", theme.fontWeight.medium, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:attachments;"));
};

var styles = {
  attachment: attachment,
  controls: controls,
  attachments: attachments
};
exports.styles = styles;
//# sourceMappingURL=Attachments.styles.js.map